<template>
	<div class="modal" :id="id" tabindex="-1" role="dialog" :aria-labelledby="id + 'Label'" aria-hidden="true">
		<div class="mt-5 mx-auto" role="document">
			<div class="modal-content bg-dark text-light">
				<div class="modal-header">
					<button type="button" class="close text-light" data-dismiss="modal" aria-label="Close">
						<span aria-hidden="true">&times;</span>
					</button>
				</div>
				<div class="mt-3 text-center">
					<h3 class="modal-title">
						Thời gian bạn chọn có lớp trùng, xin hãy chọn 1 trong các lớp dưới
					</h3>
				</div>
				<div class="modal-body overflow-auto bg-dark text-light">
					<table class="table table-striped table-dark">
						<thead>
							<tr>
								<th v-for="title in $parent.rawTitle" :key="title" class="border-left border-bottom">{{ title }}</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="c, index in $parent.overlayClasses" :key="index" @click="$parent.chooseClass([c])" class="select-class cursor-pointer">
								<td v-for="info, key in c" :key="key" class="border-left border-bottom">
									<span :class="{ 'dot-dot-dot': true, 'text-danger': key == $parent.title[$parent.titleTrans['classType']] || key == $parent.title[$parent.fileProgramTitle] }">
										{{ info }}
									</span>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: ['id'],
}
</script>